module.exports = __webpack_public_path__ + "static/img/12012D_2_3_R_20190204_fit.00511d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12012D_2_3_R_20190204_fit.png
// module id = 55q3
// module chunks = 0